import type {
  MrrMovementChartDataPoint,
  RetentionPoint,
} from '../../recurring-revenue-report-page/utils/chart-movements';

export type RetentionRow = {
  id: string;
  month: string;
  startingMrr: number;
  expansionMrr: number;
  contractionMrr: number;
  churnMrr: number;
  nrr: number;
  grr: number;
};

export function buildRetentionRows(
  monthlyMovements: MrrMovementChartDataPoint[],
  retentionPoints: RetentionPoint[],
): RetentionRow[] {
  const pointsByLabel = new Map<string, RetentionPoint>();
  for (const point of retentionPoints) {
    pointsByLabel.set(point.month, point);
  }

  const rows: RetentionRow[] = [];

  for (const movement of monthlyMovements) {
    if (movement.beginningMrr <= 0) continue;

    const point = pointsByLabel.get(movement.label);
    if (!point) continue;

    rows.push({
      id: point.monthKey,
      month: movement.label,
      startingMrr: movement.beginningMrr,
      expansionMrr: movement.expansion,
      contractionMrr: movement.contraction,
      churnMrr: movement.churn,
      nrr: point.nrr,
      grr: point.grr,
    });
  }

  return rows.reverse();
}
